import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchTripData } from 'src/services/napi/trips/fetchTripData';

const fetchTripsData = async (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
  status?: string;
}) => {
  const { orderBy, orderDirection, page, pageSize, search } = params;
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await fetchTripData({
    orderBy: orderBy || 'created',
    orderDirection: orderDirection || '-1',
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id,
    search: search || ''
  });
  return data;
};

export const useGetTrips = (params: {
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
}) => {
  const { notify } = useNotification();
  const { orderBy, orderDirection, page, pageSize, search } = params;

  return useQuery(
    [QueryKey.TRIPS, page, pageSize, orderBy, orderDirection],
    () =>
      fetchTripsData({
        orderBy,
        orderDirection,
        page,
        pageSize,
        search
      }),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
